import { HowToBuySection } from './view';
export default HowToBuySection;
